import React, { useState } from 'react';
import { Grid, Box, IconButton, Typography } from '@mui/material';
import ArrowDownward from '@mui/icons-material/ArrowDownward';
import ArrowUpward from '@mui/icons-material/ArrowUpward';
import Cancel from '@mui/icons-material/CancelOutlined';

interface DisplayOfferInGridProps {
    //Name: JSX.Element;
    Company: string;
    Profession: string;
    CompanyLogo?: JSX.Element;
    Location: string;
    Offer: JSX.Element;
    ActionButton: JSX.Element;
  }

  export const DisplayOfferInGridBody: React.FC<DisplayOfferInGridProps> = ({ Company, Profession, CompanyLogo, Location, Offer, ActionButton }) => {
    return (

      <>
      <Grid container spacing={0} >
      {/* Top row: name/profession on the left, logo on the right */}
      <Grid item xs={6} sm={8}>
        <Typography variant="bigPrimary" sx={{
          whiteSpace: 'normal',      // allow wrapping
          wordBreak: 'break-word',   // break long words
          overflowWrap: 'anywhere',  // modern fallback for long strings
        }}> {Company && Company.trim() !== "" ? Company : "Company Name"}</Typography>

        {Profession ? (
            <>
              <Typography variant="body1">{Profession}</Typography><br/>
            </>
          ) : (
            <>
              &nbsp;<br/>
            </>
          )}
      </Grid>

      <Grid container item xs={6} sm={4} justifyContent="center">
        {CompanyLogo && (
          <Grid item container justifyContent="center">
            {CompanyLogo}
          </Grid>
        )}
      </Grid>

      {/* Middle row: offer centered across the whole card */}
      <Grid item xs={12}>
        <Box display="flex" justifyContent="center" alignItems="center" py={1}>
          <Typography variant='h4'> {Offer} </Typography>
        </Box>
      </Grid>

      {/* Bottom row: location on the left, action button on the right */}
      <Grid item xs={6} sm={8}>
        {Location ? (
          <>
            <Typography variant='bigPrimary_body2'>Covering Area</Typography>
            <br/>
            {Location}
          </>
        ) : (
          <>
            <Typography variant='bigPrimary_body2'>&nbsp;</Typography>
            <br/>
            &nbsp;
          </>
        )}
      </Grid>

      <Grid item container xs={6} sm={4} alignItems="center" justifyContent="center">
        {ActionButton}
      </Grid>
      </Grid>

    </>


    
    )}

    interface DisplayOfferInGridHeaderProps {
      //Name: JSX.Element;
      Company: JSX.Element;
      CompanyLogo?: JSX.Element;
      Location: JSX.Element;
      Offer: JSX.Element;
      ActionButton: JSX.Element;
    }

export const DisplayOfferInGridHeader: React.FC<DisplayOfferInGridHeaderProps> = ({ Company, Location, Offer, ActionButton }) => {
    
  const [isGridVisible, setGridVisible] = useState(false);

  const handleVisibilityToggle = () => {
    setGridVisible(prev => !prev);
  };

  return (
    <>
     
        <Grid container spacing={0} >
          <Grid item xs={6} style={{ padding: isGridVisible ? '10px' : '0px' }}>
          {isGridVisible && (
            <Grid container spacing={0}>                        
            <Grid item xs={12}>              
              {Company} 
            </Grid>

            <Grid item xs={12}>
              {Location}
            </Grid> 
            </Grid>
          )} 
          </Grid>

          <Grid item xs={3} >
          {isGridVisible && (
            <Box display="flex" justifyContent="center" alignItems="center" height="100%">                               
              {Offer}                            
            </Box> 
          )}
          </Grid>

          <Grid item xs={3} style={{ paddingRight: '16px' }}>
            <Box display="flex" justifyContent="center" alignItems="center" height="100%">           
                <IconButton onClick={handleVisibilityToggle}>
                  {!isGridVisible ? <><ArrowDownward /><ArrowUpward /></> : <Cancel /> }
                </IconButton>        
            </Box>                        
          </Grid>
        </Grid>    
    </>
  );
}
